import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="modern-landing">
      {/* Animated background */}
      <div className="bg-canvas" aria-hidden>
        <div className="shape shape-1" />
        <div className="shape shape-2" />
        <div className="shape shape-3" />
        <div className="shape shape-4" />
        <div className="gradient-overlay" />
      </div>

      {/* Hero Section */}
      <section className="hero-modern">
        <div className="container-fluid">
          <div className="hero-content">
            <div className="hero-icon">
              <div className="icon-inner">E</div>
            </div>
            <h1 className="hero-title">
              Think Beyond
              <span className="gradient-text">Time</span>
            </h1>
            <p className="hero-description">
              Experience the future of puzzle gaming. Plan your moves, record
              your strategy, and watch time echo your genius. Every step matters
              in this elegant dance of logic.
            </p>
            <div className="hero-actions">
              <a
                className="btn-primary"
                href="https://apps.apple.com/"
                target="_blank"
                rel="noreferrer"
              >
                Download Now
                <span className="btn-arrow">→</span>
              </a>
              <Link className="btn-secondary" to="/support">
                Learn More
              </Link>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">4.9</span>
                <span className="stat-label">App Store Rating</span>
              </div>
              <div className="stat">
                <span className="stat-number">50K+</span>
                <span className="stat-label">Players Worldwide</span>
              </div>
              <div className="stat">
                <span className="stat-number">100+</span>
                <span className="stat-label">Mind-Bending Levels</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-modern">
        <div className="container-fluid">
          <div className="section-header">
            <h2>Revolutionary Gameplay</h2>
            <p>Where strategy meets innovation</p>
          </div>
          <div className="features-grid-modern">
            <div className="feature-modern">
              <div className="feature-icon">🎯</div>
              <h3>Strategic Planning</h3>
              <p>
                Every move counts. Plan your route with precision and watch your
                strategy unfold across multiple timelines.
              </p>
            </div>
            <div className="feature-modern">
              <div className="feature-icon">⚡</div>
              <h3>Time Echoes</h3>
              <p>
                Your past selves become allies. Use temporal echoes to solve
                increasingly complex spatial puzzles.
              </p>
            </div>
            <div className="feature-modern">
              <div className="feature-icon">✨</div>
              <h3>Elegant Design</h3>
              <p>
                Minimalist aesthetics meet maximum engagement. Every pixel
                crafted for the ultimate puzzle experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience-section">
        <div className="container-fluid">
          <div className="experience-grid">
            <div className="experience-content">
              <div className="section-tag">The Experience</div>
              <h2>Crafted for Perfection</h2>
              <p>
                Born from a passion for elegant problem-solving, Echo Steps
                represents years of meticulous design and innovation. We believe
                that the best puzzles don't just challenge your mind—they
                elevate it.
              </p>
              <div className="experience-features">
                <div className="exp-feature">
                  <span className="exp-icon">📱</span>
                  <span>Intuitive touch controls</span>
                </div>
                <div className="exp-feature">
                  <span className="exp-icon">🎵</span>
                  <span>Atmospheric soundscapes</span>
                </div>
                <div className="exp-feature">
                  <span className="exp-icon">🌟</span>
                  <span>Premium, ad-free experience</span>
                </div>
              </div>
            </div>
            <div className="experience-visual">
              <div className="visual-card">
                <div className="card-header">Echo Steps</div>
                <div className="game-preview">
                  <div className="preview-grid">
                    <div className="grid-cell active"></div>
                    <div className="grid-cell"></div>
                    <div className="grid-cell echo"></div>
                    <div className="grid-cell"></div>
                    <div className="grid-cell target"></div>
                  </div>
                  <div className="preview-controls">
                    <button className="control-btn">▶</button>
                    <button className="control-btn">⏸</button>
                    <button className="control-btn">↻</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-modern">
        <div className="container-fluid">
          <div className="cta-content">
            <h2>Ready to Master Time?</h2>
            <p>
              Join thousands of players in the most innovative puzzle experience
              ever created.
            </p>
            <div className="cta-actions">
              <a
                className="btn-primary large"
                href="https://apps.apple.com/"
                target="_blank"
                rel="noreferrer"
              >
                Start Your Journey
              </a>
            </div>
            <div className="legal-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>•</span>
              <Link to="/support">Support</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
